import styled from 'styled-components';

// Container principal
export const Container = styled.div`
  display: flex;
  min-height: auto;
  padding: 3rem;
  background: linear-gradient(to bottom right, #fbcfe8, #fce7f3, #e9d5ff);

  @media (max-width: 640px) {
    padding: 2rem 1rem;  
  }
`;

export const MaxWidth = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;

// Flex principal
export const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

// Conteúdo da esquerda
export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 45%;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

// Seção de texto
export const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Title = styled.h1`
  font-size: 4rem;
  font-weight: bold;
  color: #7e7e7e;
  line-height: 1.2;

 @media (max-width: 640px) {
    font-size: 2.5rem;
  }
`;

export const Highlight = styled.span`
  color: #ec4899;
`;

export const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #807f7e;
  line-height: 1.6;

 
`;

// Grid de estatísticas
export const StatsGrid = styled.div`
  display: flex;
  justify-content: space-between;
  width: 80%;
`;

export const StatItem = styled.div`
  text-align: center;
`;

export const StatIcon = styled.div`
  width: 4rem;
  height: 4rem;
  background-color: #40909f;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.75rem auto;
`;

export const IconSize = styled.div`
  width: 2rem;
  height: 2rem;
  color: white;
`;

export const StatNumber = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: #807f7e;
`;

export const StatLabel = styled.div`
  font-size: 0.875rem;
  color: #6b7280;
`;

// Seção de botões
export const ButtonSection = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

export const PrimaryButton = styled.button`
  background: linear-gradient(to right, #5E287E, #D82E88);
  color: white;
  padding: 1rem 2rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 1.125rem;
  cursor: pointer;
  border: none;
`;

export const SecondaryButton = styled.button`
  border: 2px solid #f472b6;
  color: #ec4899;
  padding: 1rem 2rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  background: white;
  height: 3.5rem;
`;

export const PlayIcon = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border: 2px solid #f472b6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PlayIconInner = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  background-color: #f472b6;
  border-radius: 50%;
`;

export const FreeText = styled.div`
  font-size: 0.875rem;
  color: #d82e88;
  font-weight: 500;
`;



export const ImagesGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: 2fr 1fr;
  gap: 1rem;
  width: 45%;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 2rem;
    height: auto;
  }

  @media (max-width: 640px) {
    width: 100%;
  }
`;

export const LargeImage = styled.div`
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  border-radius: 25px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 25px;
  }

  @media (max-width: 1024px) {
    height: 14rem;
    margin-bottom: 1rem;
  }

  @media (max-width: 640px) {
    height: 18rem;
   
  }
`;

export const SmallImagesRight = styled.div`
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 25px;
  }

  @media (max-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;

  }

  @media (max-width: 640px) {
    height: 14rem;
  }
`;

export const BottomImages = styled.div`
  grid-column: 1 / 3;
  grid-row: 2 / 3;
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 1rem;

  height: 14rem;
  
  .bottom-small, .bottom-large {
    border-radius: 25px;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    height: 6rem; 
   
  }

  @media (max-width: 640px) {
    height: 14rem;
  }
`;



// Botão flutuante
export const FloatingButton = styled.div`
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
`;

export const WhatsappButton = styled.div`
  width: 4rem;
  height: 4rem;
  background-color: #22c55e;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
`;

export const WhatsappIcon = styled.div`
  color: white;
  font-size: 1.25rem;
`;


export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const Modal = styled.div`
  background: white;
  border-radius: 12px;
  max-width: 50%;
  width: 100%;
  max-height: 80%;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  animation: modalSlideIn 0.3s ease-out;
  
  @keyframes modalSlideIn {
    from {
      opacity: 0;
      transform: scale(0.9) translateY(-20px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8f9fa;
    color: #495057;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  justify-content: center; /* Centraliza horizontalmente */
  align-items: center;
  padding-bottom: 2rem;  

  .video iframe{
    
  }

`;